__webpack_require__.p = "https://bundle.stayforlong.com/20260218.1/_next/";